/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'whale',
    quality: 0.3,
    toughness: 1,
    strength: 1,
    willpower: 1
}